import React from 'react'
import "./Error404.css"

function Error404() {
    return (
        <div className='error404'>
            <h1>Page not found</h1>
        </div>
    )
}

export default Error404